import React from 'react';
import { Input, Textarea, Select, Button, PaperClip, DatePicker } from 'components';
import moment from 'moment';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { Menu as MenuIcons, CompanyIcon, AlertIcon } from 'assets/icons';
import { RouteComponentProps } from 'react-router-dom';
import { InformationService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Home extends React.Component<Props> {

	state = {
		form: {
			human_redirect: false,
			human_message: ''
		},
		agents: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await InformationService.getData({
			user_id: this.props.user?.id
		});
		this.setState({
			agents: res.agents || [],
			form: {
				...this.state.form,
				human_redirect: res.person?.human_redirect || false,
				human_message: res.person?.human_message || ''
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();

		await InformationService.saveHumanRedirect({
			...this.state.form
		});
		Globals.showSuccess("Se ha modificado correctamente");
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="client-agent-human">
				<form onSubmit={ this.submit } className="form-black">
					<div className="container-title">
						<div className="row">
							<div className="col-md-12" style={{ display: 'flex', alignItems: 'center' }}>
								<img src={ AlertIcon } className="alert-icon" />
								<p>Activa esta opción para que, cuando la IA llegue a un punto donde no pueda ofrecer más respuestas útiles, con esta opción se ofrece que al usuario a continuar la conversación con alguien de tu equipo.</p>
							</div>							
						</div>
					</div>
					<div className="check-container" onClick={ () => this.setState({
						form: {
							...this.state.form,
							human_redirect: !this.state.form.human_redirect
						}
					}) }>
						<p>{ this.state.form.human_redirect ? 'Encendido' : 'Apagado' }</p>
						<div className={ `check ${ this.state.form.human_redirect ? 'active' : '' }` }>
							<div className="check-circle"></div>
						</div>
					</div>
					<div className="container-title gray">
						<p className={ !this.state.form.human_redirect ? 'disabled' : '' }>Puedes personalizar el mensaje que verá el cliente para ofrecerle un canal de contacto directo:</p>
					</div>
					<Textarea
						disabled={ !this.state.form.human_redirect }
						rows={ 6 }
						value={ this.state.form.human_message }
						name="human_message"
						placeholder="Parece que esta consulta necesita atención personalizada. Puedes escribirnos directamente al WhatsApp +58 412-XXX-XXXX o al correo soporte@tusitio.com."
						onChange={ (e: any) => this.change(e) } />
					<Button type="submit">
						Guardar
					</Button>
				</form>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Home);